<template lang="pug">
  .col-24.initBackgroundImage.flexD.alignItemsCenter.justifyCenter.l-padding-top-8em.l-padding-bottom-6em.l-padding-bottom-4em.m-padding-top-4em(:style="{backgroundImage:'url('+ img.bg +')'}")
    .col-18.flexD.flexDirectionColumn.minWidth768.m-minWidthAuto.m-width-100
      .col-24.flexD.justifyCenter.l-margin-bottom-4em
        .col-6.m-width-40
          img.col-24.block(:src="img.logo")
      .col-24.l-margin-bottom-4em.m-padding-left-right-5p.m-margin-bottom-0
        .font-section.textAlignLeft(v-for="(item, index) in text.section" :key="index") {{ item.content }}
      .col-24.flexD.flexDirectionRow.l-margin-bottom-4em.m-margin-top-4em.justifySpaceBetween.m-flexDirectionColumn
        .col-11.m-hidden
          img.block.col-24(:src="img.bed[0].src")
          img.block.col-21.relative(:src="img.bed[1].src" style="left: 30%; top: -1em; z-index: 1")
        .col-24.l-hidden.m-block.l-margin-bottom-4em
          q-carousel.bgColor-transparent.heightAuto(v-model="imgSlide" transition-prev="slide-right" transition-next="slide-left" swipeable animated padding arrows control-color="grey-10" navigation navigation-icon='fa fa-circle-o' navigation-active-icon='fa fa-circle')
            q-carousel-slide(v-for="(item,index) in img.bed" :name="index" :key="index")
              .col-24
                .col-24.m-height-30vh.initBackgroundImage(:style="{backgroundImage:'url('+ item.src +')'}")

        .col-12.textAlignLeft.relative.m-width-100.m-padding-left-right-5p
          .font-title.lineHeight1EM.color-green.m-textAlignCenter {{ text.title.text }}
          .font-title-small.color-green.m-textAlignCenter.m-margin-bottom-1em {{ text.title.des }}
          ul.font-ul.l-margin-top-2em.l-margin-bottom-4em.m-margin-bottom-2em
            li.lineHeight2EM(v-for="(t, i) in text.list" :key="i") {{ t }}
          img.inlineBlock.l-margin-top-1em.col-21.absolute.textAlignRight.m-hidden(:src="img.bed[2].src" style="right: 0")
      .col-24.msFlexNegative
        q-carousel.bgColor-transparent.heightAuto(v-model="slide" prev-icon="img:./icon_prev.png" next-icon="img:./icon_next.png" transition-prev="slide-right" transition-next="slide-left" swipeable animated control-color="grey-10" navigation padding arrows navigation-icon='fa fa-circle-o' navigation-active-icon='fa fa-circle')
          q-carousel-slide(v-for="(item,index) in videos" :name="index" :key="index")
            .col-24
              .font-section.l-margin-top-1em.l-margin-bottom-1em.textAlignLeft.m-textAlignCenter {{ item.text }}
              .msFlexNegative.col-24
                video.block.col-24(:src="item.url" controls="controls" :poster="item.poster")
      .col-24.flexD.alignItemsCenter.justifyCenter.flexDirectionColumn.msFlexNegative
        .col-21.flexD.flexDirectionRow.alignItemsCenter.l-margin-top-4em.justifySpaceBetween.m-flexDirectionColumn.msFlexNegative(v-for="(item, index) in text.items" :key="index")
          .col-14.m-width-100.msFlexNegative
            img.col-24.block(:src="item.img")
          .col-9.textAlignLeft.m-width-90.m-margin-top-2em
            .font-title-small.color-font-middGary {{ item.title }}
            ul.font-ul
              li.lineHeight2EM(v-for="(t, i) in item.list" :key="i") {{ t }}
      .col-24.flexD.justifyCenter.l-margin-top-4em
        q-btn(v-if="isPc" outline @click="openPopup(0)" :label="text.more" padding="3px 2.5em" :style="{ color: '#2196f3', fontSize: '1em' }")
        a.btn-blue(v-else :href="pdf" :style="{ color: '#2196f3', fontSize: '1em', padding: '3px 2.5em' }" download target="_blank") {{ text.download }}
    PopupWibo(ref="popupWibo" :content="popupValue")
</template>

<script>
  import PopupWibo from '../popup/popupWibo.vue'

  export default {
    name: 'wibo',
    props: ['content'],
    components: {
      PopupWibo,
      'q-btn': Quasar.QBtn,
      'q-carousel': Quasar.QCarousel,
      'q-carousel-slide': Quasar.QCarouselSlide
    },
    data(){
      return{
        text: {
          section: [
            { content: this.$t('wibo.content_1') },
            { content: this.$t('wibo.content_2') },
          ],
          title: {
            text: this.$t('wibo.title_text'),
            des: this.$t('wibo.title_des')
          },
          list: [this.$t('wibo.list_1'), this.$t('wibo.list_2'), this.$t('wibo.list_3')],
          items: [
            {
              img: require('@/assets/img/sentida_5.png'),
              title: this.$t('wibo.item_1.title'),
              list: [this.$t('wibo.item_1.list_1'),this.$t('wibo.item_1.list_2'),this.$t('wibo.item_1.list_3'),this.$t('wibo.item_1.list_4')]
            },
            {
              img: require('@/assets/img/sentida_6.png'),
              title: this.$t('wibo.item_2.title'),
              list: [this.$t('wibo.item_2.list_1'),this.$t('wibo.item_2.list_2'),this.$t('wibo.item_2.list_3'),this.$t('wibo.item_2.list_4')]
            },
          ],
          more: this.$t('dietz.more'),
          download: this.$t('common.download_btn')
        },
        pdf: "./doc/wibo_pdf.pdf",
        img: {
          bed: [
            { src: require('@/assets/img/wibo_bed_1.png') },
            { src: require('@/assets/img/wibo_bed_2.png') },
            { src: require('@/assets/img/wibo_bed_3.png') },
          ],
          bg: require('@/assets/img/bg_wibo.png'),
          logo: require('@/assets/img/logo/logo_wibo.png'),
        },
        videos: [
          { url: require('@/assets/media/wibo_1.mp4'), text: this.$t('wibo.video_1'), poster: require('@/assets/img/cover_wibo_1.jpg') },
          { url: require('@/assets/media/wibo_1.mp4'), text: this.$t('wibo.video_2'), poster: require('@/assets/img/cover_wibo_2.jpg') },
        ],
        slide: 0,
        imgSlide: 0,
        popupValue: {
          popup: false,
          index: 0
        }
      }
    },
    computed: {
      isPc() {
        if (this.Common.getUserAgent() != 'PC') {
          return false
        }
        return true
      }
    },
    methods:{
      openPopup(index){
        this.popupValue = {
          popup: true,
          index: index
        }
      },
    },
    created(){}
  }
</script>
